<template>
  <a-form ref='form' :model='search'  :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
    <a-form-item name='keywords'>
      <a-input-group compact style="width:370px">
        <a-select v-model:value="search.type" style="width: 32%" @change="inputSelect">
          <a-select-option value="dealer_name">经销商名称</a-select-option>
          <a-select-option value="dealer_sn">经销商编号</a-select-option>
          <a-select-option value="leader_name">负责人</a-select-option>
          <a-select-option value="leader_phone">手机号</a-select-option>
        </a-select>
        <a-input style="width: 68%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
      </a-input-group>
    </a-form-item>
    <a-form-item class='mb15' label="地址" name='keywords'>
       <selectCity class="m-r-20" :addressData='address' v-on:citychange='citychange'>
              </selectCity>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType='submit'>搜索</a-button>
    </a-form-item>
  </a-form>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='dealer_id' :columns='columns' :data-source='data'>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" />
</template>

<script>
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { getDealerListSelect } from "@/api/dealer";
import { iscode } from "@/utils/app";
// 初始化默认筛选项数值
let defSearch = {
  keyword: "",
  page: 1,
  limit: 5,
  status: 1,
  type: "dealer_name",
  is_sub_store: 1,
  is_sub_dealer: 1,
  province:null,
  city:null,
  area:null,
  sub_brand_id:""
};
export default {
  name: "selectDealer",
  components: {},
  props: {
       currentData:Object
  },
  setup(props, { emit }) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([]);
    const state = reactive({
      listLoading: false,
      time: [],
      total: 1,
      selectedRowKeys: [],
      selectList: [],
      selectIds: [],
    });
    let columns = [
      {
        title: "经销商编号",
        dataIndex: "dealer_sn",
        key: "dealer_sn",
      },
      {
        title: "经销商名称",
        dataIndex: "dealer_name",
        key: "dealer_name",
      },
      {
        title: "经销商级别",
        dataIndex: "level_name",
        key: "level_name",
      },
      {
        title: "经销商地址",
        dataIndex: "area",
        key: "area",
        width:300
      },
      {
        title: "负责人",
        dataIndex: "leader_name",
        key: "leader_name",
      },
      {
        title: "手机号码",
        dataIndex: "leader_phone",
        key: "leader_phone",
      },
    ];
    const $router = inject("$router");
    const $Modal = inject("$Modal");
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    const initData = async (values) => {
      state.listLoading = true;
      try {
        let res = await getDealerListSelect({
          ...values,
          parent_dealer_id:props.parent_dealer_id
        }).then((res) => res.data);
        state.listLoading = false; 
        if (iscode(res)) {
          data.value = res.data.list;
          state.total = res.data.total;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };

    onMounted(() => {
        if(props.currentData){
          search.value.sub_brand_id=props.currentData.id
        }
      initData(search.value);
    });
       //选择省市区
    const citychange = (e) => {
        search.value.province = e[0]
        search.value.city = e[1]
        search.value.area = e[2]
      }
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      citychange
    };
  },
};
</script>